import { render, staticRenderFns } from "./LeccionF6.vue?vue&type=template&id=e2acd0b4&"
import script from "./LeccionF6.vue?vue&type=script&lang=js&"
export * from "./LeccionF6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports